import ManageChoicesTable from './ManageChoiceTable';
import { useStoreId } from '../../stateless/ProductedRoute';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ManageChoices = () => {
   const { t, i18n } = useTranslation();
    const [, forceUpdate] = useState({});
  const storeId = useStoreId();

  // / Force re-render when language changes
    useEffect(() => {
      const handleLanguageChange = () => {
        forceUpdate({});
      };
  
      i18n.on('languageChanged', handleLanguageChange);
      
      return () => {
        i18n.off('languageChanged', handleLanguageChange);
      };
    }, [i18n]);
  


  if (!storeId) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        No store assigned. Please contact administrator.
      </div>
    );
  }
  return (
        <>
          <Typography variant="h5" fontWeight="bold" mb={2}>
           {t('choice.title')}
          </Typography>
          <ManageChoicesTable
            storeId={storeId}
            
          />
        </>
  );
};

export default ManageChoices;
